export default __webpack_public_path__ + "static/media/profile-picture-girl-1.ca5eab87.svg";